/// <amd-module name="TFS/Views/ProjectOverviewPage/Actions/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

import { MembersData, ProjectOverviewPageData } from "TFS/Views/ProjectOverviewPage/Shared/Models";

export class ActionsHub {
    public projectOverviewPageLoaded = new Action<ProjectOverviewPageData>();
    public projectOverviewPageLoadFailed = new Action<void>();

    // Project Member
    public projectMembersFetched = new Action<MembersData>();
    public projectMembersFetchFailed = new Action<string>();
}
